import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './ContactUs.css';

const ContactUs = () => {
    document.title = '聯絡我們';
  return (
    <Container className="contact-us-container">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="contact-us-card">
            <Card.Body>
              <Card.Title className="contact-us-title">聯絡我們</Card.Title>
              <Card.Text className="contact-us-text">
                <strong>商店名稱：</strong>E.Y. Studio
              </Card.Text>
              <Card.Text className="contact-us-text">
                <strong>地址：</strong>10699 台北六張犁郵局第109號信箱
              </Card.Text>
              <Card.Text className="contact-us-text">
                <strong>Email：</strong>
                <a href="mailto:admin@nogi46.me" className="contact-us-link">
                  admin@nogi46.me
                </a>
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ContactUs;
